<template>
  <div>
    <div class="form-item">
      <div class="form-label">Vai trò của bạn:</div>
      <div class="form-input">
        <strong class="font-bold">{{ getRole }}</strong>
      </div>
    </div>
    <div class="form-item">
      <div class="form-label">Công việc của bạn:</div>
      <div class="form-input">
        <template v-if="taskInfo?.handlerRes?.userId === currentUser.userId">
          <span v-if="[EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(taskInfo?.status)"
            >Xử lý công việc</span
          >
          <span v-else>Công việc đã kết thúc</span>
        </template>
        <template v-else>
          <span>Không có hành động nào</span>
        </template>
      </div>
    </div>

    <template
      v-if="
        taskInfo?.handlerRes?.userId === currentUser.userId &&
        [EnumTaskStatus.NEW, EnumTaskStatus.PROCESSING].includes(taskInfo?.status)
      "
    >
      <div class="form-item">
        <div class="form-label">Thông tin chăm sóc:</div>
        <div class="form-input">
          <div><span class="text-danger">*</span>: là bắt buộc phải nhập</div>
        </div>
      </div>
      <div class="form-item">
        <div class="form-label">Thu thập thông tin:</div>
        <div class="form-input">
          <div>Trả lời ít nhất <strong class="font-bold"> 1 </strong> câu</div>
          <div>
            Với câu hỏi phụ chọn <strong class="font-bold">Có</strong> thì bạn phải chọn thêm câu
            hỏi phụ
          </div>
        </div>
      </div>

      <div class="form-item">
        <div class="form-label">[Lưu]:</div>
        <div class="form-input">
          <div>
            Nhập <strong class="font-bold">Thông tin chăm sóc</strong> và
            <strong class="font-bold">thu thập thông tin</strong> để lưu,
          </div>
          <div><strong class="font-bold">Thời gian thực hiện công việc</strong> là optional</div>
          <div v-if="result === EnumTaskResultStatus.FAILED && !reasonFailure">
            Hãy nhập <strong class="font-bold">Lý do thất bại</strong>
          </div>
        </div>
      </div>
      <div class="form-item">
        <div class="form-label">[Hoàn thành]:</div>
        <div class="form-input">
          <template v-if="[EnumTaskStatus.NEW].includes(taskInfo?.status)">
            Không thể lưu (trạng thái phải là đang xử lý)
          </template>
          <template v-else>
            <template v-if="isChange">
              Cần nhấn <strong class="font-bold">Lưu</strong> trước và cập nhật
              <strong class="font-bold">hoàn thành</strong> sau
            </template>
            <template v-else>
              <template
                v-if="dateProcessing.startDate && dateProcessing.endDate && countImageExplain > 0"
              >
                Bạn có thể chọn <strong class="font-bold">Hoàn thành</strong>
              </template>
              <template v-else>
                <div v-if="!(dateProcessing.startDate && dateProcessing.endDate)">
                  <strong class="font-bold">Thời gian thực hiện công việc</strong> cần chọn - cần
                  chọn thời gian trước ngày hiện tại
                </div>
                <div v-if="countImageExplain === 0">
                  <strong class="font-bold">Ảnh giải trình</strong> hãy thêm ảnh
                </div>
              </template>
            </template>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { EnumTaskStatus, EnumTaskResultStatus } from '@/constant/customerSupport'

  export default {
    name: 'AssistanceInfomation',
    props: {
      taskInfo: {
        type: Object,
        default: () => ({}),
      },
      currentUser: {
        type: Object,
        default: () => ({}),
      },
      isChange: {
        type: Boolean,
        default: false,
      },
      dateProcessing: {
        type: Object,
        default: () => ({
          startDate: null,
          endDate: null,
        }),
      },
      result: {
        type: String,
        default: '',
      },
      reasonFailure: {
        type: String,
        default: '',
      },
      countImageExplain: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        EnumTaskStatus,
        EnumTaskResultStatus,
      }
    },
    computed: {
      getRole() {
        const roles = []
        if (this.taskInfo) {
          if (this.taskInfo?.createdBy === this.currentUser.userId) {
            roles.push('Người tạo')
          }
          if (this.taskInfo?.handlerRes?.userId === this.currentUser.userId) {
            roles.push('Người xử lý')
          }
          return roles.join(', ')
        }
        return 'Guest'
      },
    },
  }
</script>

<style scoped lang="scss">
  .form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;

    &:first-child {
      margin-top: 0;
    }

    .form-label {
      font-weight: 400;
      font-size: 14px;
      color: #2a2a2a;
      //max-width: 150px;

      &.require::after {
        content: '*';
        color: #f00;
        margin-left: 4px;
      }
    }

    .form-input {
      width: 60%;

      .error {
        color: #f00;
      }
    }
  }
</style>
